import React, { Component } from 'react';
import LoadableComponent from '../../common-components/PlaceholderLoading/LoadableComponent';
import ContentLoadPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/ContentLoadPlaceholder';
import ContentLoadErrorPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/ContentLoadErrorPlaceholder';
import { Translation } from "react-i18next";
import { LoadScript } from '../../types/LoadScript';
import { Configuration } from '../../types/Configuration';
import { ApiErrorEvent, ErrorEventType } from '../../common-components/Notifications/Events';

type Props = {
    configuration: Configuration
    accessToken: string,
    selectedLanguage: string,
    onLoadCallback: () => void,
    onErrorCallback: () => void,
    tokenIsProvided: boolean,
    companyId: string
}

type State = {
    scriptsToBeLoaded: Array<LoadScript>,
    loadableComponent: any
    hasApiError: boolean;
}

class PaymentMethods extends Component<Props, State> {
    loadableComponentRef: React.RefObject<any>;
    constructor(props: Props) {
        super(props);
        this.state = {
            scriptsToBeLoaded: [ {} as LoadScript, {} as LoadScript ],
            loadableComponent: null,
            hasApiError: false
        };
        this.loadableComponentRef = React.createRef();
    }

    componentDidMount(){
        this.setState({
            scriptsToBeLoaded: [
                { url: `${this.props.configuration.paymentMethodsComponentBaseUrl}/build/payment-methods.esm.js`, type: "module", nomodule: false },
                { url: `${this.props.configuration.paymentMethodsComponentBaseUrl}/build/payment-methods.js`, type: "text/javascript", nomodule: true }
            ]
        })
        
        this._setEventListeners()
    }

    _setEventListeners() {
        document.addEventListener('apiErrorEvent', ((event: CustomEvent<ApiErrorEvent>) => {
            if (event.detail.errorType === ErrorEventType.FatalError && event.detail.webComponentName === 'payment-methods') {
                this.setState({hasApiError: true})
                this.loadableComponentRef.current.handleOutsideApiError();
            }
        }) as EventListener);
    }

    render() {
        const message = <Translation>{t => t(`Unfortunately we could not load "Payment Methods".`)}</Translation>;

        return (
            <LoadableComponent
                loadPlaceholder={ContentLoadPlaceholder}
                errorPlaceholder={ContentLoadErrorPlaceholder}
                scriptsToBeLoaded={this.state.scriptsToBeLoaded}
                message={message}
                ref={this.loadableComponentRef}
                {... this.props}>
                <payment-methods
                    token-is-provided={this.props.tokenIsProvided}
                    base-api-url={this.props.configuration.paymentMethodsApiUrl}
                    email-address="orders@docuware.com"
                    language={this.props.selectedLanguage}
                    company-id={this.props.companyId}>
                </payment-methods>
            </LoadableComponent>
        )
    }
}

export default PaymentMethods;